export const environment = {
  production: true,
  region: 'us-east-1',
  userPoolId: 'us-east-1_RWbFugC2E',
  userPoolWebClientId: 'jusjfsqcup6vcphrdjj6kmvln',
};
